var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "field-body" }, [
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Count")]),
      _c("div", { staticClass: "control" }, [
        _c("span", [_vm._v(_vm._s(_vm.count))]),
      ]),
    ]),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Avg Labour (Hrs)")]),
      _c("div", { staticClass: "control" }, [
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.$filters.formatNumber(
                _vm.averageLabourUnits,
                _vm.$userInfo.locale
              )
            )
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [
        _c("span", [_vm._v("ALR")]),
        _c(
          "span",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value:
                  _vm.alr < _vm.alrLowerThreshold ||
                  _vm.alr > _vm.alrUpperThreshold,
                expression:
                  "alr < alrLowerThreshold || alr > alrUpperThreshold",
              },
            ],
            staticClass: "icon has-text-danger tooltip is-tooltip-danger",
            attrs: {
              "data-tooltip":
                _vm.alr < _vm.alrLowerThreshold
                  ? "ALR is below threshold"
                  : "ALR is above threshold",
            },
          },
          [_c("i", { staticClass: "mdi mdi-alert" })]
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "control",
          class: {
            "has-text-danger":
              _vm.alr < _vm.alrLowerThreshold ||
              _vm.alr > _vm.alrUpperThreshold,
          },
        },
        [
          _c("span", [
            _vm._v(
              _vm._s(_vm.$filters.formatCurrency(_vm.alr, _vm.$userInfo.locale))
            ),
          ]),
        ]
      ),
    ]),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Avg Labour ($)")]),
      _c("div", { staticClass: "control" }, [
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.$filters.formatCurrency(
                _vm.averageLabourValues,
                _vm.$userInfo.locale
              )
            )
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Avg Non-Labour ($)")]),
      _c("div", { staticClass: "control" }, [
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.$filters.formatCurrency(
                _vm.averageNonLabourValues,
                _vm.$userInfo.locale
              )
            )
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Avg Total")]),
      _c("div", { staticClass: "control" }, [
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.$filters.formatCurrency(
                _vm.averageTotalExGst,
                _vm.$userInfo.locale
              )
            )
          ),
        ]),
      ]),
    ]),
    _c("div", { staticClass: "field" }, [
      _c("label", { staticClass: "label" }, [_vm._v("Adjusted Total")]),
      _c("div", { staticClass: "control" }, [
        _c("span", [
          _vm._v(
            _vm._s(
              _vm.$filters.formatCurrency(
                _vm.adjustedTotal,
                _vm.$userInfo.locale
              )
            )
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }